<template>
  <div class="patient-record-menu">
    <tablet-menu-entry
      :router-link-to="{
        name: 'PatientRecordOverview',
        params: { patientId },
      }"
      icon="mdi-home-outline"
      exact
      :enabled="true"
      :name="$t('patient.patientOverview')"
    />
    <tablet-menu-entry
      :router-link-to="{
        name: 'PatientRecordProgress',
        params: { patientId },
      }"
      icon="mdi-heart-outline"
      :enabled="true"
      :name="$t('buttons.journey', {catalog: 'app_mobile'})"
    />
    <tablet-menu-entry
      :router-link-to="{
        name: 'PatientRecordMedicaton',
        params: { patientId },
      }"
      icon="mdi-pill"
      :enabled="isModuleEnabled('MEDICATIONS')"
      :name="$t('screens.medicationAdherenceScreen', {catalog: 'app_mobile'})"
    />
    <tablet-menu-entry
      :router-link-to="{
        name: 'PatientRecordPA',
        params: { patientId },
      }"
      icon="mdi-run"
      :enabled="isModuleEnabled('STARTMOVING')"
      :name="$t('screens.startMovingSettingsScreen', {catalog: 'app_mobile'})"
    />
    <tablet-menu-entry
      :router-link-to="{
        name: 'PatientRecordHN',
        params: { patientId },
      }"
      icon="mdi-silverware-fork-knife"
      :enabled="isModuleEnabled('HEALTHYNUTRITION')"
      :name="$t('screens.healthyNutritionSettingsScreen', {catalog: 'app_mobile'})"
    />
    <tablet-menu-entry
      :router-link-to="{
        name: 'PatientRecordSmoking',
        params: { patientId },
      }"
      icon="mdi-smoking-off"
      :enabled="isModuleEnabled('SMOKECESSATION')"
      :name="$t('screens.smokeFreeLivingSettingsScreen', {catalog: 'app_mobile'})"
    />
    <tablet-menu-entry
      :router-link-to="{
        name: 'PatientRecordStress',
        params: { patientId },
      }"
      icon="mdi-meditation"
      :enabled="isModuleEnabled('STRESSMANAGEMENT')"
      :name="$t('screens.stressReliefSettingsScreen', {catalog: 'app_mobile'})"
    />
    <tablet-menu-entry
      :router-link-to="{
        name: 'PatientRecordKnowledge',
        params: { patientId },
      }"
      icon="mdi-book-open-blank-variant"
      :enabled="isModuleEnabled('KNOWLEDGE')"
      :name="$t('screens.increaseYourKnowledgeSettingScreen', {catalog: 'app_mobile'})"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TabletMenuEntry from "./TabletMenuEntry";

/**
 * Component TabletMenu.vue
 *
 * @module TabletMenu
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/templates/components/Parts/TabletMenu.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "TabletMenu",
  components: { TabletMenuEntry },
  computed: {
    ...mapGetters({
      patientId: 'patientSummary/id',
      isModuleEnabled: "enabledModules/getIsModuleEnabled",
    }),
  },
  methods: {}
};
</script>

<style lang="scss">
@import "../../../../scss/colors";

.patient-record-menu {
  padding: 24px 32px 24px 20px;
  border-right: 1px solid #d6dbe4;
  min-height: 100%;
}

// mobile first
.c-tablet-menu-entry {
  display: block;
}

// mobile screens

// tablet screens

// desktop/large screens

// -------------------------------------------------- BEM modifiers ------------------------------------------------
</style>
